import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchfilterDateRange',
  pure: true,
  standalone: false,
})
export class SearchfilterDateRangePipe implements PipeTransform {
  transform(value: Array<any>, attributeName: string, start?: any, to?: any): Array<any> {
    if (!start || !to) {
      return value;
    } else {
      const startDate = new Date(start);
      const endDate = new Date(to);
      return value.filter((m) => {
        const itemDate = new Date(m[attributeName]);
        return itemDate >= startDate && itemDate <= endDate;
      });
    }
  }
}
